// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LdEk","col":"styles_col__3oQXn","actions":"styles_actions__2zfVv","conflict":"styles_conflict__3Gmym"};